const PanelContainer = {
  baseStyle: {
    p: {
      base: "30px 15px",
      xl: "16px 15px 30px 15px",
    },
    minHeight: {
      base: "calc(100vh - 123px)",
      xl: "calc(100vh - 30px)",
    },
  },
};

export const PanelContainerComponent = {
  components: {
    PanelContainer,
  },
};

